module.exports = __webpack_public_path__ + "img/1-3.18c95fb2.png";